// Wait for document initializsation
$(document).ready(function() {
  // Declare slide switch interval
  var CAROUSEL_DURATION = 15 * 1000;
  
  // Assign click handler for the carousel indicators
  // Upon clicked, the carousel, well switch to the slide
  // corresponding to the clicked indicator
  $('body').on('click', '.block-carousel__indicators__indicator', function($event) {
    // Prevent potential native click actions from indicators
    $event.preventDefault();
    
    // Current indicator
    var $indicator = $(this);
    // All indicators
    var $indicators = $indicator.siblings();
    // Current carousel
    var $carousel = $indicator.parent().siblings('.block-carousel');
    // Current item wrapper
    var $itemWrapper = $carousel.find('.block-carousel__items');

    // Set the current index of the carousel, to be the index of the clicked indicators
    $carousel.data('current', $indicator.index());

    // Move the carousel to the chosen slide
    $itemWrapper.css({
      left: ($indicator.index() * 100 * - 1) + '%'
    });

    // Reset active indicator
    $indicators.removeClass('block-carousel__indicators__indicator--active');
    // Choose the current indicator as the active indicator
    $indicator.addClass('block-carousel__indicators__indicator--active');
  });

  // Initialize each carousel element
  $('.block-carousel').each(function() {
    // Current carousel
    var $carousel = $(this);
    // Indicators of the carousel
    var $indicators = $carousel.siblings('.block-carousel__indicators').find('.block-carousel__indicators__indicator');
    // Item wrapper
    var $itemWrapper = $carousel.find('.block-carousel__items');
    // Slides (items) of the carousel
    var $items = $carousel.find('.block-carousel__items__item');

    // Give the carousel a fixed height (here, its initial height)
    $carousel.height($carousel.height());

    // Initialize the interval, with which the carousel, will switch it's slides
    setInterval(function() {
      // Get the index of the current slide (or start from 0)
      var index = parseInt($carousel.data('current'), 10) || 0;

      // If the index is equal the number of slides, reset it to be 0
      if (index == $items.size()) {
        index = 0;
      }

      // Set and remember the current index for the carousel
      $carousel.data('current', index + 1);

      // Move the carousel to the chosen slide
      $itemWrapper.css({
        left: (index * 100 * -1) + '%'
      });

      // Reset the active indicator
      $indicators.removeClass('block-carousel__indicators__indicator--active');
      // Choose the new indiator as the active indicator
      $indicators.eq(index).addClass('block-carousel__indicators__indicator--active');
    }, CAROUSEL_DURATION);
  });

  // Assign listener, to listen on window resize events,
  // we want to adjust the height of the carousel, because
  // of the mobile version of the carousel. We are 
  // debouncing the event, to use less resources.

  window.addEventListener("orientationchange", function() {
    // For each carousel
    $('.block-carousel').each(function() {
      // Reference to the current carousel
      var $carousel = $(this);

      // Reset the height of the carousel
      $carousel.height('auto');

      // Wait until the dom has rerendered (this is very hacky,
      // but the particular sequence of events leading to this,
      // is very, very rare to occur. Actually, its mostly for
      // demo purposes).
      setTimeout(function() {
        // Give the carousel its new fixed height,
        // for all of the slides to expand to the carousels
        // max height
        $carousel.height($carousel.height());
      }, 250);
    });
  }, false);

  if ($('.block-carousel').length) {
    var $swiper = new Hammer($('.block-carousel').get(0));
    $swiper.on('swipeleft swiperight', function(ev) {
      // Find indicators
      var $indicators = $('.block-carousel__indicators').children();

      // Find active
      var $active = $indicators.filter('.block-carousel__indicators__indicator--active');

      // Go forward or backwards
      if (ev.type === 'swiperight') {
        $active.prev().trigger('click');
      } else {
        $active.next().trigger('click');
      }
    });
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/carousel.js
 ** module id = 2
 ** module chunks = 0
 **/